import React from "react";
import styles from "./Pagination.module.css";

export default function Pagination({
  totalPages,
  currentPage,
  setCurrentPage,
}) {
  return (
    <section aria-label="Pagination">
      <div className={styles.pagination}>
        <div className={styles.containerForBtn}>
          <span
            onClick={() => {
              window.scrollTo(0, 0);
              setCurrentPage((p) => Math.max(p - 1, 1));
            }}
            className={styles.paginationBtn}
            aria-disabled={currentPage === 1}
            style={{
              display: currentPage === 1 ? "none" : "",
            }}
          >
            <p>&lt;</p>
          </span>
        </div>
        <div className={styles.paginationNum}>
          {(() => {
            const windowSize = 5;
            const pages = [];

            let startPage = Math.max(
              1,
              currentPage - Math.floor(windowSize / 2)
            );
            let endPage = startPage + windowSize - 1;

            if (endPage >= totalPages - 1) {
              endPage = totalPages - 1;
              startPage = Math.max(1, endPage - windowSize + 1);
            }

            for (let page = startPage; page <= endPage; page++) {
              pages.push(
                <span
                  key={page}
                  onClick={() => {
                    if (currentPage !== page) {
                      window.scrollTo(0, 0);
                      setCurrentPage(page);
                    }
                  }}
                  style={{
                    fontWeight: currentPage === page ? "700" : "500",
                    color: currentPage === page ? "white" : "black",
                    backgroundColor:
                      currentPage === page ? "#333537" : "transparent",
                  }}
                  className={styles.paginationBtn}
                >
                  <p>{page}</p>
                </span>
              );
            }

            if (totalPages > 1 && endPage < totalPages) {
              pages.push(
                <span
                  key={totalPages}
                  onClick={() => {
                    if (currentPage !== totalPages) {
                      window.scrollTo(0, 0);
                      setCurrentPage(totalPages);
                    }
                  }}
                  style={{
                    fontWeight: currentPage === totalPages ? "700" : "500",
                    color: currentPage === totalPages ? "white" : "black",
                    backgroundColor:
                      currentPage === totalPages ? "#333537" : "transparent",
                  }}
                  className={styles.paginationBtn}
                >
                  <p>{totalPages}</p>
                </span>
              );
            }

            return pages;
          })()}
        </div>
        <div className={styles.containerForBtn}>
          <span
            onClick={() => {
              window.scrollTo(0, 0);
              setCurrentPage((p) => Math.min(p + 1, totalPages));
            }}
            className={styles.paginationBtn}
            aria-disabled={currentPage === totalPages}
            style={{
              display: currentPage === totalPages ? "none" : "",
            }}
          >
            <p>&gt;</p>
          </span>
        </div>
      </div>
    </section>
  );
}
